/* -disable import/prefer-default-export */
import styled from 'styled-components';

const StyledModal = styled.div`
  max-height: 90vh;
  && {
    top: 5vh
    overflow: auto;
  };
`;

export const S = {
  StyledModal,
};
